import React                                 from 'react';
import { Observe }                           from 'rewire-core';
import {
  WithStyle,
}                                            from 'rewire-ui';
import { MuiThemeProvider, Theme }           from '@material-ui/core/styles';
import Typography                            from '@material-ui/core/Typography';
import { withStyles }                        from '../utility/styles';
import OptionsActionMenu                     from '../ui/OptionsActionMenu';
import {
  timeOffRequestTheme,
  TimeOffRequestHeaderTitle,
  TimeOffRequestContents,
}                                            from '../timeoff/InfoPanelTimeOffRequestView';
import infoPanelShiftTimeOffRequestViewModel from './InfoPanelShiftTimeOffRequestViewModel';
import { DefaultTheme }                      from '@material-ui/styles';


const styles = (_theme: Theme) => ({
  headerContainer: {
    overflowX: 'hidden',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
});

interface IInfoPanelTimeOffRequestViewProps {
  classes?: any;
}

type InfoPanelTimeOffRequestViewProps = WithStyle<ReturnType<typeof styles>, IInfoPanelTimeOffRequestViewProps>;

class InfoPanelTimeOffRequestView extends React.PureComponent<InfoPanelTimeOffRequestViewProps> {
  constructor(props: InfoPanelTimeOffRequestViewProps) {
    super(props);
  }

  render() {
    return <Observe render={() => {
      const { classes }          = this.props;
      const showPanel            = infoPanelShiftTimeOffRequestViewModel.shouldShowPanel();
      const headerTitleHidePanel = 'No approved time off requests for this shift';
      const headerOptionsTitle   = 'Time Off Request Options';
      const headerOptionsItems   = infoPanelShiftTimeOffRequestViewModel.optionsActionMenuItems;

      return (
        <MuiThemeProvider theme={timeOffRequestTheme as DefaultTheme}>
          < >
            {showPanel
              ? < >
                  <div className={classes.headerContainer}>
                    <TimeOffRequestHeaderTitle model={infoPanelShiftTimeOffRequestViewModel} />
                    <OptionsActionMenu title={headerOptionsTitle} tooltip={headerOptionsTitle} style={{margin: 0}} items={headerOptionsItems} />
                  </div>
                  <TimeOffRequestContents model={infoPanelShiftTimeOffRequestViewModel} />
                </>
              : <div className={classes.headerContainer}>
                  <Typography variant='h5'>{headerTitleHidePanel}</Typography>
                </div>
            }


          </>
        </MuiThemeProvider>
      );
    }} />;
  }
}

export default withStyles(styles, InfoPanelTimeOffRequestView);
